import { Button, DatePicker, Form, Input, Popconfirm, Table, Tooltip, Typography } from "antd";
// import './AdjustmentsComponents.css';
import "../../GlobalCss/SPF/AdjustmentsComponents.css"
import AddNewAdjustment from "./AddNewAdjustment";
import { CheckOutlined, CloseOutlined, DeleteOutlined, EditOutlined, PlusOutlined, RollbackOutlined, SearchOutlined } from "@ant-design/icons";
import DynamicColumns from "./DynamicColumns";
import { useEffect, useState } from "react";
import { DeleteAdjustment, DiscardAdjustmentsData, FetchAdjustmentsData, FetchEADColumns, FetchHistoricAdjustmentsData, GetFileNumberForAdjustment, PostNewAdjustment, RollBackAdjustment, SaveAdjustmentsToMaster, UpdateAdjustment } from "../../Repository/AdjustmentsRepository";
import { ErrorMessage, InfoMessage, ReplaceUnderscoreWithSpace, StringValidations, SuccessMessage, WarnMessage } from "../../Utils/Utils";
import ExcelJS from "exceljs";
import FileSaver from "file-saver";
import GetHistoricAdjustments from "./HistoricAdjustments";


//Filter Feature for Grid Layout
const filterProps = (SearchGridValue) => (
    {
        filteredValue: [SearchGridValue],
        onFilter: (value, record) => {
            return (
                String(record.File_Number).toLowerCase().includes(value.toLowerCase()) ||
                String(record.Employee_Name).toLowerCase().includes(value.toLowerCase())
            )
        }
    }
);

//Sort Feature for Grid Layout
const sortProps = (column) => {
    if (column === "File_Number" || column === "Category") {
        return (
            {
                sorter: (a, b) => a[column].localeCompare(b[column]),
                sortDirections: ['descend', 'ascend'],
                showSorterTooltip: false,
            }
        )
    }
};

//download the default template to upload adjustments
const handleDownloadAdjustmentTemplate = (selectedColumns, DefaultHeaders) => {
    let SelectedHeadersArray = selectedColumns.map((data) => data.value);
    let TemplateHeaders = [...DefaultHeaders, ...SelectedHeadersArray];
    let ExcelReadyHeaders = TemplateHeaders.map((header, index) => (ReplaceUnderscoreWithSpace(header)));
    const workbook = new ExcelJS.Workbook();
    const worksheet = workbook.addWorksheet('Sheet1');
    worksheet.addRow(ExcelReadyHeaders);
    return workbook.xlsx.writeBuffer().then(buffer => {
        const blob = new Blob([buffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
        FileSaver.saveAs(blob, 'AdjustmentTemplate.xlsx');
    })
}

const AdjustmentsGrid = ({ loadGrid, setLoadGrid, dataSource, setDataSource, frequency, payDate, dynamicColumns, setDynamicColumns, selectedColumns, setSelectedColumns, HistoricJSX }) => {


    const [searchGridValue, setSearchGridValue] = useState(""); //input field value to search in grid
    const [editingKey, setEditingKey] = useState("");
    const [oldData, setOldData] = useState([]);
    const [NewRecordKey, setNewRecordKey] = useState(null);
    const [AddRecordSearch, setAddRecordSearch] = useState("");
    const [confirmationFlag, setConfirmationFlag] = useState(false);
    const [searchedEmployee, setSearchedEmployee] = useState({});
    const [form] = Form.useForm();
    const isEditing = (record) => record.Ticket_Number === editingKey;

    const handleEdit = async (record) => {
        setEditingKey(record.Ticket_Number);
        form.setFieldsValue({ ...record });
        setOldData([...dataSource]);
    }

    const handleCancel = async () => {
        setEditingKey("");
        setNewRecordKey("");
        setDataSource([...oldData]);
        form.resetFields();
    }

    const handleDelete = async (record) => {
        const Response = await DeleteAdjustment(record.Ticket_Number);
        if (Response != null) {
            if (Response.statusCode === 200) {
                SuccessMessage(Response.message);
                await FetchAdjustmentsData(frequency, setLoadGrid, setDataSource);
                form.resetFields();
            }
            else {
                ErrorMessage(Response.message);
            }
        }
        else {
            ErrorMessage("Unable to delete Adjustment!!!")
        }
    }

    const handleSave = async (record) => {
        let ModifiedData = form.getFieldsValue();
        Object.entries(ModifiedData).map(item => { record[item[0]] = item[1]; return item });
        if (StringValidations(record?.File_Number)) {
            const Response = await UpdateAdjustment(record);
            if (Response.statusCode === 200) {
                SuccessMessage(Response.message);
                setEditingKey("");
                await FetchAdjustmentsData(frequency, setLoadGrid, setDataSource);
                form.resetFields();
            }
            else {
                ErrorMessage(Response.message);
            }
        }
        else {
            WarnMessage("Please add file number!!!");
        }
    }

    const OnConfirmationProcess = () => {
        setNewRecordKey(searchedEmployee.Ticket_Number);
        setEditingKey(searchedEmployee.Ticket_Number);
        setOldData([...dataSource]);
        setDataSource([searchedEmployee, ...dataSource]);
        setConfirmationFlag(false);
        form.setFieldsValue({ ...searchedEmployee });
    }
    const OnConfirmationCancel = () => {
        setConfirmationFlag(false);
    }
    function ConvertFrequency(text) {
        if (text === "B") {
            return "B_ADJ";
        }
        else if (text === "W") {
            return "W_ADJ";
        }
    }
    const handleAddNewAdjustment = async () => {
        if (StringValidations(AddRecordSearch)) {
            const Response = await GetFileNumberForAdjustment(AddRecordSearch);
            if (Response.statusCode === 200) {
                let SearchedData = JSON.parse(Response.payload);
                setSearchedEmployee(SearchedData);
                if (!StringValidations(editingKey)) {
                    if (SearchedData.Frequency != ConvertFrequency(frequency)) {
                        setConfirmationFlag(true);
                    }
                    else {
                        setNewRecordKey(SearchedData.Ticket_Number);
                        setEditingKey(SearchedData.Ticket_Number);
                        setOldData([...dataSource]);
                        setDataSource([SearchedData, ...dataSource]);
                        form.setFieldsValue({ ...SearchedData });
                    }
                }
                else {
                    InfoMessage("Please save/discard the new record...")
                }
            }
            else {
                WarnMessage(`Could not find ${AddRecordSearch}`)
                if (editingKey === "") {
                    let NewRecordArray = {};
                    for (let index in columns) {
                        NewRecordArray[columns[index].dataIndex] = "";
                    }
                    NewRecordArray.Ticket_Number = "0";
                    setOldData([...dataSource]);
                    setDataSource([NewRecordArray, ...dataSource]);
                    setNewRecordKey("0");
                    setEditingKey("0");
                    form.setFieldsValue({ ...NewRecordArray });
                }
            }

        }
        else {
            WarnMessage("Please enter File Number");
        }
    }

    const handleSaveNewRecord = async () => {
        let NewRecord = form.getFieldsValue();
        if (StringValidations(NewRecord?.File_Number)) {

            if (StringValidations(NewRecord?.Pay_Date)) {
                const Response = await PostNewAdjustment(NewRecord, frequency);
                if (Response.statusCode === 200) {
                    SuccessMessage(Response.message);
                    setEditingKey("");
                    setNewRecordKey("");
                    await FetchAdjustmentsData(frequency, setLoadGrid, setDataSource);
                }
                else {
                    ErrorMessage(Response.message);
                }
            }
            else {
                WarnMessage("Please add Pay Date!!!  (Note : MM/DD/YYYY format)")
            }
        }
        else {
            WarnMessage("Please add file number!!!")
        }
    }

    const handleSaveToMaster = () => {
        const AsyncExecute = async () => {
            await SaveAdjustmentsToMaster(frequency);
            await FetchAdjustmentsData(frequency, setLoadGrid, setDataSource);
        }
        AsyncExecute();
    }
    const handleDiscardAdjustments = () => {
        const AsyncExecute = async () => {
            await DiscardAdjustmentsData(frequency);
            await FetchAdjustmentsData(frequency, setLoadGrid, setDataSource);
        }
        AsyncExecute();
    }

    const handleRollbackAdjustments = (record) => {
        const AsyncExecute = async () => {
            await RollBackAdjustment(record);
            await FetchHistoricAdjustmentsData(payDate, frequency, setLoadGrid, setDataSource);
        }
        AsyncExecute();
    }
    const columns = [
        ...dynamicColumns.DefaultHeaders.map((column, index) => ({
            title: ReplaceUnderscoreWithSpace(column),
            dataIndex: column,
            key: column,
            ellipsis: true,
            width: 120,
            editable: true,
            ...filterProps(searchGridValue),
            ...sortProps(column),
        })),
        ...selectedColumns.map((column, index) => ({
            title: ReplaceUnderscoreWithSpace(column.value),
            dataIndex: column.value,
            key: column.value,
            ellipsis: true,
            width: 120,
            editable: true,
        })),
        ...dynamicColumns.DefaultHeaders.length <= 0 ? [] : [
            {
                title: "Action",
                dataIndex: "action",
                key: "edit",
                fixed: "right",
                editable: false,
                width: 100,
                render: (_, record) => {
                    const editable = isEditing(record);
                    return (
                        record.Adjustment_Status?.trim() === "Submitted" ?
                            <>
                                <Tooltip title="Click to rollback adjustment" color="blue">
                                    <RollbackOutlined
                                        className="adjustments-rollback-icon"
                                        onClick={() => {
                                            handleRollbackAdjustments(record);

                                        }}
                                    />
                                </Tooltip>
                            </> :
                            editable ? (
                                <span>
                                    {
                                        record.Ticket_Number === NewRecordKey ?
                                            <PlusOutlined
                                                onClick={handleSaveNewRecord}
                                            />
                                            :
                                            <Popconfirm
                                                title="Sure to Save?"
                                                placement="topRight"
                                                onConfirm={() => handleSave(record)}
                                            >
                                                <a>
                                                    <CheckOutlined style={{ color: "green", marginRight: "5px" }} />
                                                </a>
                                            </Popconfirm>
                                    }

                                    <Typography.Link
                                        onClick={() => handleCancel()}
                                        style={{
                                            marginRight: 8,
                                        }}
                                    >
                                        <CloseOutlined style={{ color: "red" }} />
                                    </Typography.Link>
                                </span>
                            ) : (
                                <div>
                                    <Typography.Link
                                        disabled={editingKey !== ""}
                                        onClick={() => handleEdit(record)}
                                    >
                                        <EditOutlined />
                                    </Typography.Link>
                                    <Popconfirm
                                        title="Sure to Delete?"
                                        placement="topRight"
                                        onConfirm={() => handleDelete(record)}
                                    >
                                        <a>
                                            <DeleteOutlined
                                                style={{ color: "#fa5946", marginLeft: "10px" }}
                                            />
                                        </a>
                                    </Popconfirm>
                                </div>
                            )
                    )
                }
            }
        ]
    ];

    const mergedColumns = columns.map((col) => {
        if (!col.editable) {
            return col;
        }
        return {
            ...col,
            onCell: (record) => ({
                record,
                inputType: "text",
                dataIndex: col.dataIndex,
                title: col.title,
                editing: isEditing(record),
            }),
        };
    });

    const EditableCell = ({
        editing,
        dataIndex,
        title,
        inputType,
        record,
        index,
        children,
        ...restProps
    }) => {
        const inputNode = <Input />;
        return (
            <td {...restProps}>
                {editing ? (
                    <Form.Item
                        name={dataIndex}
                        style={{
                            margin: 0,
                        }}
                    >
                        {inputNode}
                    </Form.Item>
                ) : (
                    children
                )}
            </td>
        );
    };

    const GridSummationData = (pageData, column) => {
        let RequiredColumn = dynamicColumns.EADCodes.filter(data => data === column.dataIndex);
        if (RequiredColumn.length > 0) {
            let Total = 0;
            const ColumnName = RequiredColumn[0];
            pageData.forEach((data) => {
                if (StringValidations(data[ColumnName])) {
                    Total = Total + parseFloat(data[ColumnName]);
                }
            })
            return (Number.isInteger(Total)) ? Total : Total.toFixed(2);
        }
        else {
            return "";
        }
    }

    useEffect(() => {
        FetchEADColumns(setDynamicColumns, setLoadGrid);
    }, []);

    return (
        <>
            <div className="adjustments-grid-operative-section">
                <div className="adjustments-search-section">
                    <AddNewAdjustment
                        AddRecordSearch={AddRecordSearch}
                        frequency={frequency}
                        setAddRecordSearch={setAddRecordSearch}
                        handleAddNewAdjustment={handleAddNewAdjustment}
                        confirmationFlag={confirmationFlag}
                        OnConfirmationProcess={OnConfirmationProcess}
                        OnConfirmationCancel={OnConfirmationCancel}
                    />
                    <Input
                        className={`adjustments-search-grid ${StringValidations(frequency) ? "" : "disable-adjustment-search"}`}
                        placeholder="Search File Number/Employee Name"
                        suffix={<SearchOutlined style={{ color: `${StringValidations(frequency) ? "rgba(0, 58, 140, 1)" : "#D9D9D9"}` }} />}
                        onChange={(event) => setSearchGridValue(event.target.value)}
                    />
                </div>
                <div className="adjustments-dynamic-columns-section">
                    <DynamicColumns dynamicColumns={dynamicColumns} setSelectedColumns={setSelectedColumns} selectedColumns={selectedColumns} dataSource={dataSource} />
                    <Button className="adjustments-template" onClick={() => handleDownloadAdjustmentTemplate(selectedColumns, dynamicColumns.DefaultHeaders)}>Download Template</Button>
                    <HistoricJSX />
                </div>
            </div>
            <div className="adjustments-grid-container">
                <Form form={form} component={false}>
                    <Table
                        components={{
                            body: {
                                cell: EditableCell
                            }
                        }}
                        columns={mergedColumns}
                        dataSource={dataSource}
                        className={`adjustments-grid ${StringValidations(frequency) ? "" : "disable-adjustments-grid"}`}
                        bordered
                        scroll={{ x: 'max-content', y: 300 }}
                        loading={loadGrid}
                        pagination={false}
                        summary={(pageData) => {
                            return (
                                StringValidations(frequency) ?
                                    <Table.Summary fixed={"bottom"}>
                                        <Table.Summary.Row style={{ textAlign: "center" }}>
                                            {
                                                columns.map((column, index) => (
                                                    <Table.Summary.Cell index={index}>
                                                        {GridSummationData(pageData, column)}
                                                    </Table.Summary.Cell>
                                                ))
                                            }
                                        </Table.Summary.Row>
                                    </Table.Summary>
                                    :
                                    <></>
                            )
                        }}
                    />
                </Form>
            </div>
            <div className="master-buttons-container">
                <Button className={`save-to-master ${StringValidations(frequency) ? "" : "disable-save-to-master-adjustments-button"}`} onClick={() => {
                    handleSaveToMaster();
                }} disabled={StringValidations(payDate)}>Save to master</Button>
                <Button className={`discard-adjustments ${StringValidations(frequency) ? "" : "disable-discard-adjustments-button"}`} onClick={() => {
                    handleDiscardAdjustments();
                }} disabled={StringValidations(payDate)} ghost>Discard</Button>
            </div>
        </>
    )
}

export default AdjustmentsGrid;